import { render, staticRenderFns } from "./smsconfig.vue?vue&type=template&id=6c5b54d0&"
import script from "./smsconfig.vue?vue&type=script&lang=ts&"
export * from "./smsconfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "smsconfig.vue"
export default component.exports